<div class="flex w-full items-start gap-x-8">
    <interacta-ai-convo-thinking-loader
        [isDark]="isDark()"
        [thoughts]="shownThoughts()"
    />
    <p class="grid grow typo-sm text-text-mid-contrast">
        @for (entry of current(); track entry.id) {
            <span
                animate.enter="animate-ticker-in motion-reduce:animate-none"
                animate.leave="animate-ticker-out motion-reduce:animate-none"
                class="col-start-1 row-start-1"
                [attr.aria-hidden]="entry.announce ? null : true"
            >
                {{ entry.key | translate: entry.params }}
            </span>
        }
    </p>
</div>
